import styled from 'styled-components'
import LevelRatingQuestionLabelLayout from '../LevelRatingQuestionLabelLayout.mobile'
import InputAnswerItemMobile, {
  InputAnswerItemMobileProps,
} from './InputAnswerItem.mobile'

interface InputQuestionProps {
  questioonLabel: string
  answerList: InputAnswerItemMobileProps[]
}

const InputQuestionMobile = ({
  questioonLabel,
  answerList,
}: InputQuestionProps) => {
  return (
    <StyledWrapper>
      <LevelRatingQuestionLabelLayout label={questioonLabel}>
        <div className="input-layout">
          {answerList.map(
            (
              { answer, questionId, questionSeq, inputQuestionSubject },
              index,
            ) => {
              return (
                <InputAnswerItemMobile
                  answer={answer}
                  key={`${answer.id}-${index}`}
                  questionId={questionId}
                  inputQuestionSubject={inputQuestionSubject}
                  questionSeq={questionSeq}
                />
              )
            },
          )}
        </div>
      </LevelRatingQuestionLabelLayout>
    </StyledWrapper>
  )
}

export default InputQuestionMobile

const StyledWrapper = styled.div`
  margin-bottom: 44px;

  .input-layout {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`
